export default __webpack_public_path__ + "static/media/javascript.edc1b02f.png";